<div>
  <div *ngIf="visible" style="position: absolute; right: {{offset}}; bottom: {{offset}};">
    <button nbTooltip="Ir arrriba" style="transform: rotate(180deg);padding: 0.2rem;z-index: 1000;" nbButton ghost  (click)="onPressed()">
      <app-icon fontSize="2rem" class="{{currentAnimationComponent}}" [status]="statusCalculated" [icon]="icon"></app-icon>
    </button>
  </div>
</div>

